import ENUMS from '../enums/registryEnums';
import { createEnumReducer } from '../../../core/js/utils/reducerUtils';

export const registryReducer = createEnumReducer(ENUMS);
